export default "__VITE_ASSET__kFaRVqFM__"